export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.31-1530.11",
  commitId: "88e777bf95f6664d67c28d8132fed6bf5e5221c7",
  commitTime: "2026-07-31T15:30:11.000Z",
});
